import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import TrackChangesLabelEditing from './trackchangeslabelediting';

export default class TrackChangesLabel extends Plugin {
  static get requires() {
    return [ TrackChangesLabelEditing ];
  }

  static get pluginName() {
    return 'TrackChangesLabel';
  }
}